import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from './theme';
import { AppLayout } from './components/layout/AppLayout';
import { ProtectedRoute } from './components/common/ProtectedRoute';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { DashboardPage } from './pages/DashboardPage';
import { TaskListPage } from './pages/TaskListPage';
import { TaskDetailPage } from './pages/TaskDetailPage';
import { ProcessListPage } from './pages/ProcessListPage';
import { ProcessDetailPage } from './pages/ProcessDetailPage';
import { NewProcessPage } from './pages/NewProcessPage';
import { DocumentsPage } from './pages/DocumentsPage';
import { BpmnEditorPage } from './pages/BpmnEditorPage';
import { ProcessDefinitionsPage } from './pages/ProcessDefinitionsPage';
import { KeyManagementPage } from './pages/KeyManagementPage';
import { AuthoritiesListPage } from './pages/AuthoritiesListPage';
import { AuthorityPage } from './pages/AuthorityPage';
import { EmployeeInboxPage } from './pages/EmployeeInboxPage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30000,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="tasks" element={<TaskListPage />} />
              <Route path="tasks/:taskId" element={<TaskDetailPage />} />
              <Route path="processes" element={<ProcessListPage />} />
              <Route path="processes/new" element={<NewProcessPage />} />
              <Route path="processes/definitions" element={<ProcessDefinitionsPage />} />
              <Route path="processes/:processId" element={<ProcessDetailPage />} />
              <Route path="documents" element={<DocumentsPage />} />
              <Route path="admin/bpmn-editor" element={<BpmnEditorPage />} />
              <Route path="admin/keys" element={<KeyManagementPage />} />
              <Route path="admin/authorities" element={<AuthoritiesListPage />} />
              <Route path="admin/authorities/:authorityId" element={<AuthorityPage />} />
              <Route path="admin/inbox" element={<EmployeeInboxPage />} />
              <Route path="admin/inbox/:authorityId" element={<EmployeeInboxPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
